import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import OperationDetailsService from "../../../../services/AuraCamera/operation-details/operation-details.service";
import Helpers from "../../../../utils/helpers";

const LeakPopup = (props: any) => {
  const videoRef = useRef(null);
  const [frameCount, setFrameCount] = useState(0);

  const [AllKlvData, setAllKLVData] = useState([]);

  const [displayKLVinTable, setdisplayKLVinTable] = useState<any>([]);
  const session = window.localStorage;
  const [UnitPref, UpdateUnitPref] = useState<any>(
    session.getItem("UnitPrefWebApp")
  );
  const [modalVisible, setModalVisible] = useState(false);
  const [VideoURL, setVideoURL] = useState("");
  const [Obs_Sequence, setObs_Sequence] = useState("");

  const [leakButton, setleakButton] = useState([]);
  const lkvideo = useRef<HTMLInputElement | any>(null);
  const handleLeakVideo = (media_location: any, klv_json_location: any) => {
    OperationDetailsService.GetKLV(klv_json_location).then((klv_data: any) => {
      setTimeout(() => {
      setAllKLVData(klv_data);

        setVideoURL(
          process.env.REACT_APP_BLOB_URL + media_location
        );
        setModalVisible(true);
      }, 1000);
    });
    lkvideo.current?.play();
  };
  useEffect(() => {
    setObs_Sequence(props?.locationData?.obs_sequence);
    if (props?.locationData?.hasEmission == 1) {
      let temp_button_data: any = [];
      props.locationData.emissionData.map(
        (emission_data_val: any, emission_data_index: number) => {
          temp_button_data.push(
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                handleLeakVideo(
                  emission_data_val.mp4_location,
                  emission_data_val?.klv_json
                );
                // handle KLV Api
              }}
            >
              {`Target ${emission_data_val?.target_sequence}`}
            </button>
          );
        }
      );
      setleakButton(temp_button_data);
    }
  }, [props]);

  useEffect(() => {
    // Update frame count on time updates
    const updateFrameCount = () => {
      // if (video) {
      UpdateUnitPref(session.getItem("UnitPrefWebApp"));

      const video: any = lkvideo.current;

      if (lkvideo.current != null) {
        const currentTime: any = video.currentTime;
        const duration = video.duration;
        const currentFrame = Math.floor(currentTime * frameRate);

        setFrameCount(currentFrame);
        setdisplayKLVinTable(AllKlvData[currentFrame]);
      }

      // }
    };

    // Set up interval timer to update frame count
    const intervalId = setInterval(updateFrameCount, 500); // Update every second

    return () => {
      clearInterval(intervalId); // Clean up interval on unmount
    };
  }, [AllKlvData]);
  const frameRate = 30; // Adjust this to your video's frame rate
  return (
    <>
      <div className="mapBtnWindow">
        <div className="mapPlaceTitle">
          <span style={{}}>
            {`${props?.locationData?.title}`}
            <br></br>
            {props?.locationData?.RouteName + " - Observation " + Obs_Sequence}
          </span>
        </div>
        <div className="d-grid mapBtnList">{leakButton}</div>
        <Dialog
          header="Leak KLV Data"
          visible={modalVisible}
          modal={false}
          onHide={() => setModalVisible(false)}
          className="mapModal"
        >
          <div className="leakVideo">
            <div className="leakVideo-wrapper">
              <div className="leakVideo-wrapper__inner">
                <video ref={lkvideo} controls className="videoFile">
                  <source src={VideoURL} type="video/mp4" />
                  {/* <source src="/v1.mp4" type="video/mp4" /> */}
                </video>
              </div>
            </div>
            <div className="klvData-wrapper">
              <div className="klvData-wrapper__inner">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Field</th>
                      <th scope="col">Values</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Timestamp</th>
                      <td>
                        {Helpers.ConvertUtcToLocalReadableFullDate(
                          displayKLVinTable?.timestamp?.[0]
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Latitude</th>
                      {/* sensorLatitude */}
                      <td>
                        {displayKLVinTable?.sensorLatitude?.[0].toFixed(7)}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Longitude</th>
                      <td>
                        {displayKLVinTable?.sensorLongitude?.[0].toFixed(7)}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Air temperature</th>
                      <td>
                        {Helpers.UniteConversion(
                          UnitPref,
                          displayKLVinTable?.outsideAirTemperature?.[0].toFixed(1),
                          "temperature"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Platform heading angle</th>
                      <td>
                        {displayKLVinTable?.platformHeadingAngle?.[0].toFixed(
                          1
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Platform pitch angle</th>
                      <td>
                        {displayKLVinTable?.platformPitchAngleFull?.[0].toFixed(1)}
                        {displayKLVinTable?.platformPitchAngle?.[0].toFixed(1)}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Platform roll angle</th>
                      <td>
                        {displayKLVinTable?.platformPitchRollFull?.[0].toFixed(1)}
                        {displayKLVinTable?.platformRollAngle?.[0].toFixed(1)}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Altitude </th>
                      <td>
                        {displayKLVinTable?.sensorTrueAltitude?.[0].toFixed(1)}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Wind speed</th>
                      <td>
                        {Helpers.UniteConversion(
                          UnitPref,
                          displayKLVinTable?.windSpeed?.[0].toFixed(1),
                          "wind_speed"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Ground range</th>
                      <td>
                        {Helpers.UniteConversion(
                          UnitPref,
                          displayKLVinTable?.groundRange?.[0].toFixed(0),
                          "ground_range"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Fuel remains</th>
                      <td>{displayKLVinTable?.platformFuelRemaining?.[0]}</td>
                    </tr>
                    <tr>
                      <th scope="row">Pitch angle</th>
                      <td>
                        {displayKLVinTable?.platformPitchAngleFull?.[0].toFixed(
                          1
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Pitch roll</th>
                      <td>
                        {displayKLVinTable?.platformPitchRollFull?.[0].toFixed(
                          1
                        )}
                      </td>
                    </tr>
                    {/* <tr>
                    <th scope="row">checksum</th>
                    <td>{displayKLVinTable?.checksum}</td>
                  </tr> */}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    </>
  );
};

export default LeakPopup;
